@use '../../../styles/Constants.scss' as Constants;

.attachmentCell {
	display: block;
	text-overflow: ellipsis;
	overflow:hidden;
	white-space:nowrap;
	user-select: text;
}

.cellIcon {
	margin-right: Constants.$val-spacing-l;
}
